const getBasketType = items => {
    const basketIncludesTeamStoreProduct = !!items.find(
        item => !!item.productReference?.customAttributes?.attrTeamwearTeamCode
    );

    const basketIncludesRegularProduct = !!items.find(
        item => item && !item.productReference?.customAttributes?.attrTeamwearTeamCode
    );

    if (basketIncludesTeamStoreProduct && basketIncludesRegularProduct) {
        return 'TEAMMIX';
    }

    if (basketIncludesTeamStoreProduct) {
        return 'TEAM';
    }

    if (basketIncludesRegularProduct) {
        return 'INLINE';
    }

    return null;
};

export default getBasketType;
